import { UiNewsletter } from "libs/raas-ui-react-components/src/components";

export default function TranslationComponent(props: any) {
    return (
        <>
            <UiNewsletter></UiNewsletter>
        </>

    )
}
